import { DEFAULT_LOCALE, syncHtmlLang } from '@/locales'

const localeModule = {
  namespaced: true,
  state: {
    locale: localStorage.getItem('locale') || DEFAULT_LOCALE
  },
  getters: {
    locale: state => state.locale
  },
  mutations: {
    SET_LOCALE(state, locale) {
      state.locale = locale
      localStorage.setItem('locale', locale)
      syncHtmlLang(locale)
    }
  },
  actions: {
    setLocale({ commit, rootState }, locale) {
      commit('SET_LOCALE', locale)
    }
  }
}

syncHtmlLang(localeModule.state.locale)

export default localeModule



// WEBPACK FOOTER //
// ./src/store/modules/locale.js